import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { doseDataState } from '~/state/atoms/dose/doseAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { buildTargetDoseLookup } from '~/utils/transforms/doseTargetsTransforms';

/**
 * Map of structure (current) name → prescribed dose (Gy) for the
 * targets of the loaded dose. Empty when no dose / no targets.
 */
const useDoseTargetLookup = (): Map<string, number> => {
    const doseData = useRecoilValue(doseDataState);
    const structureSet = useRecoilValue(currentStructureSetState);

    return useMemo(() => {
        const nameByRoiNumber = new Map<number, string>();
        for (const roi of structureSet?.roiArray ?? []) {
            nameByRoiNumber.set(roi.roiNumber, roi.name);
        }
        return buildTargetDoseLookup(doseData?.targets, (roiNumber) =>
            nameByRoiNumber.get(roiNumber)
        );
    }, [doseData?.targets, structureSet]);
};

export default useDoseTargetLookup;
